import CardLineIcon from '../shared/Icons/CardLineIcon';
import ContactlessPaymentIcon from '../shared/Icons/ContactlessPaymentIcon';

export const PosBottomSheetType = {
  TOP_UP_CARD: 'TOP_UP_CARD',
  TOP_UP_POS: 'TOP_UP_POS',
};

export const PosBottomSheetProvider = (t, organization) => {
  return {
    title: t('Top up'),
    titleStyle: 'bottom-sheet-title',
    items: [
      {
        type: PosBottomSheetType.TOP_UP_CARD,
        icon: <CardLineIcon />,
        title: t('Top Up {card name} card', {
          '{card name}': organization,
        }),
      },
      {
        type: PosBottomSheetType.TOP_UP_POS,
        icon: <ContactlessPaymentIcon />,
        title: t('Top up your POS'),
      },
    ],
    alertStyle: 'bottom-sheet-items',
    buttonTitle: t('Confirm'),
  };
};
